// CustomFilter.tsx
import React, {useState, useImperativeHandle, forwardRef, useEffect, useCallback, useRef} from 'react';
import {IFilterComp, IFilterParams, IDoesFilterPassParams} from 'ag-grid-community';
import Button from '../Button';
import {Dropdown} from 'semantic-ui-react';
interface DropDownFilterProps extends IFilterParams {
    dataSource: any[];
    width: string;
    filterKey: string;
}

interface DropDownFilterModel {
    filterText: Array<any>;
}

const DopDownFilter = forwardRef<Partial<IFilterComp>, DropDownFilterProps>((props, ref) => {
    const [filterText, setFilterText] = useState<Array<any>>([]);
    const dataSource = props.dataSource || [];
    const [dropdownOpen, setDropdownOpen] = useState(false); // Track dropdown state

    // Mark filter as active if filterText has content
    const isFilterActive = () => filterText.length > 0;

    // Define the filter logic
    const doesFilterPass = useCallback(
        (params: IDoesFilterPassParams) => {
            if (props.filterKey === 'status') {
                const status = params.data[props.colDef.field as string];
                if (filterText.includes('1')) {
                    return status.indexOf('_RESET') === -1;
                } else {
                    return status.indexOf('_RESET') > -1;
                }
            } else if (props.filterKey === 'derivates') {
                const {colDef} = props;
                const value = params.data[colDef.field as string];
                return value.some((v: any) =>
                    filterText.some((filter: string | number) =>
                        v.names[0].name.toString().toLowerCase().includes(filter.toString().toLowerCase())
                    )
                );
            } else {
                const {colDef} = props;
                const value = params.data[colDef.field as string];
                if (props.filterKey) {
                    return value.some((v: any) =>
                        filterText.some((filter: string | number) =>
                            v[props.filterKey].toString().toLowerCase().includes(filter.toString().toLowerCase())
                        )
                    );
                }
                return value
                    .split(',')
                    .some((v: any) =>
                        filterText.some((filter: string) =>
                            v.toString().toLowerCase().includes(filter.toLowerCase())
                        )
                    );
            }
        },
        [filterText, props]
    );

    useImperativeHandle(
        ref,
        () =>
        // @ts-ignore
        ({
            isFilterActive,
            doesFilterPass,
            getModel: () => (filterText ? {filterText} : null),
            setModel: (model: DropDownFilterModel | null) => setFilterText(model ? model.filterText : filterText)
        }));
    // Clear the filter
    const clearFilter = () => {
        setFilterText([]); // Reset the filter text to empty
        setTimeout(
            () => {
                props.api.setFilterModel(null); // Remove the filter model to clear the filter icon
                props.filterChangedCallback(); // Force AG Grid to re-evaluate filters
            });
    };
    const adjustHeight = () => {
        const dropdownMenu: any = document.querySelector('.ag-react-container'); // Select the dropdown menu
        if (dropdownOpen) {
            const menuHeight: any = document.querySelector('.visible.menu.transition');
            if (dropdownMenu && menuHeight && menuHeight.offsetHeight) {
                dropdownMenu.style.height = `${menuHeight.offsetHeight + 80}px`;
            } else {
                dropdownMenu.style.height = '300px';
            }
        } else if (dropdownMenu) {
            dropdownMenu.style.height = 'auto';
        }
    };
    // Adjust height dynamically when dropdown opens/closes
    useEffect(
        () => {
            setTimeout(
                () => {
                    adjustHeight();
                },
                100
            );

        },
        [dropdownOpen]
    );
    // Update the filter text and trigger AG Grid's filter callback
    const onFilterChange = (e: React.ChangeEvent<HTMLSelectElement>, {value}: any) => {
        setFilterText(value);
        if (value !== '') {
            setTimeout(
                () => {
                    adjustHeight();
                    props.filterChangedCallback(); // Force AG Grid to re-evaluate filters
                },
                100
            )
                ;
        } else {
            clearFilter();
        }

    };

    return (
        <div className='select-filter-container'>
            {dataSource.length > 0 && (
                <Dropdown
                    placeholder='Please select'
                    selection={true}
                    multiple={true}
                    upward={false}
                    scrolling={true}
                    options={dataSource.map((item) => ({
                        key: item.key,
                        text: item.text,
                        value: item.value
                    }))}
                    onFocus={() => setDropdownOpen(true)} // Triggered when dropdown gets focus
                    onBlur={() => setDropdownOpen(false)} // Triggered when dropdown loses focus
                    onChange={onFilterChange}
                    value={filterText}
                    style={{width: props.width}}
                />
            )}

            <Button
                icon='close'
                className='close-filter'
                onClick={clearFilter}
            />
        </div>
    );
});

export default DopDownFilter;



// WEBPACK FOOTER //
// ./src/components/kuma/DropDownFilter.tsx